"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";

/** Live/connecting status dot. */
export function LiveDot(t0) {
  const $ = _c(11);
  const {
    phase
  } = t0;
  const live = phase === "live";
  const t1 = live ? "animate-ping bg-red-400/70" : "bg-amber-400/70";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("absolute inline-flex h-full w-full rounded-full motion-reduce:animate-none", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = live ? "bg-red-500" : "bg-amber-500";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("relative inline-flex h-2.5 w-2.5 rounded-full", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden={true}>{t3}{t6}</span>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}